export default {"src":"/_next/static/media/wallet_money_40.4b1d17ac.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};